// extracted by mini-css-extract-plugin
export default {"line-chart":"ProfitLossHistoryChart_line-chart__BVolJ","title-chart":"ProfitLossHistoryChart_title-chart__W-XZO","img-line-chart":"ProfitLossHistoryChart_img-line-chart__P0taP"};